export function buildLinkBoosterSourceUrl(
  routePath: string,
  openFilter: { key: string; value: string } | null,
): string {
  return openFilter
    ? `${routePath}?${openFilter.key}=${encodeURIComponent(openFilter.value)}`
    : routePath
}
